import { Box, FormControl, Grid, TextField, Typography, styled } from "@mui/material";
import styles from "./facilityUsageAgreementForm.module.scss";
import { useEffect, useState, useContext, createContext } from "react";
import { object, string } from "yup";
import { CommonButton, CommonOutlinedButton, CustomMenuItem, CustomRequiredInputLabel, CustomSelectForHallContract, CustomTextFeildForHallSchedule, CustomTextFeildforFamily } from "../../common/StyledComponents/StyledFields";
import ErrorPopup from "../../common/ErrorPopup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserName,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import { isNil, isUndefined, cloneDeep } from "lodash";
import constants from "../../../config/constants.json";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { hallRentalListProps } from "../../../infrastructure/GlobalContextProvider";
import { FormBodyContext } from "../hallContractForm";
import FormThree from "../formThree/formThree";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import FormFooter from "../formFooter";
import useSharedState, { initialState } from "../useSharedState";
import HallBookingRequest from "../hallBookingRequest";

interface formDataTypes {
  username: string;
  address: string;
  contact: string;
  email: string;
  date: string;
  time: string;
  natureEvent: string;
  guestsExpected: string;
  eventHall: string;
  eventRoom: string;
}

interface errorMsgTypes {
  username: string;
  address: string;
  contact: string;
  email: string;
  date: string;
  time: string;
  natureEvent: string;
  guestsExpected: string;
  eventHall: string;
  eventRoom: string;
}

interface FacilityUsageAgreementFormProps {
  updateMethod: (newState: any) => void;
  handleNext: () => void;
  updatedReqBody: (newState: any) => void;
  reqBody: any;
  sign: string;
}

export const HallBookingRequestResponseContext = createContext<HallBookingRequest>(initialState);

const FacilityUsageAgreementForm = (props: FacilityUsageAgreementFormProps) => {

  const [hallList, setHallList] = useState<hallRentalListProps[]>([]);
  const [sign, setSign] = useState("");
  const [error, setError] = useState("");

  const formFields = {
    username: "",
    address: "",
    contact: "",
    email: "",
    date: "",
    time: "",
    natureEvent: "",
    guestsExpected: "",
    eventHall: "",
    eventRoom: "",
  };
  const [formData, setFormData] = useState({ ...props.reqBody });
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<errorMsgTypes>({
    ...formFields,
  });
  const [searchParam] = useSearchParams();
  const username = searchParam.get("username");
  const numberOfGuests = searchParam.get("numberOfGuests");
  const hallName = searchParam.get("hallName") || "";
  const eventTime = searchParam.get("eventTime") || "";
  const eventDate = searchParam.get("eventDate") || "";
  const address = searchParam.get("address") || "";

  const hallBookingId = searchParam.get("hallBookingId");
  const status = searchParam.get("STATUS");
  const contractId = searchParam.get("contractId");
  const sharedState = useSharedState(parseInt(hallBookingId ?? "0"),parseInt(contractId ?? "0"),status ?? "");
  

  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );
  
  const eventType = searchParam.get("eventType") || "";
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.hallRentalList,
      includeToken: true,
    })
      .then((res) => {
        setHallList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);
  const [managerFormBody, setManagerFormBody] = useState({
    agreementExecutionDay: "",
    agreementExecutionMonth: "",
    agreementExecutionYear: "",
  });
  const formBody = useContext(FormBodyContext);
  const finalBody = { ...formBody, managerFormBody };
  const [nextStep, setNextStep] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(props.reqBody?.contractForm.phoneNumber);

  useEffect(() => {
    if (!isNil(username)) {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.getDevoteeDetails}/${username?.toUpperCase()}`,
        includeToken: true,
      })
        .then((res) => {
          setFormData((prevState: any) => ({
            ...prevState,
            contractForm: {
              ...prevState.contractForm,
              address: res.data.address,
              email: res.data.email,
              phoneNumber: res.data.phoneWork,
            },
          }));

          // setFormData({
          //   ...formData,
          //   address: res.data.address,
          // });
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={false}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  }, []);

  const handleFieldChange = (field: string, value: any, fieldIndex?: number) => {
    let updatedValue = field === "eventHallId" ? cloneDeep(formData.contractForm.eventHallId) : value;
    if(field === "eventHallId" && fieldIndex !== undefined){
      const currentHall = hallList[value];
      updatedValue[fieldIndex] = value;//currentHall.id;
      setFormData({
        ...formData,
        contractForm: {
          ...formData.contractForm,
          [field]: updatedValue,
        }
      });
    }else{
      setFormData({
        ...formData,
        [field]: updatedValue
      });
    }
  };

  const managerHandleFieldChange = (field: string, value: any) => {
    setManagerFormBody({
      ...managerFormBody,
      [field]: value,
    });
  };

  console.log(formData, "formData")

  const validationSchema = object().shape({
    username: string().required("User Name is required"),
    address: string().required("Address is required"),
    contact: string().required("Phone Number is required"),
    email: string().required("Email is required"),
    date: string().required("Date is required"),
    time: string().required("Time is required"),
    natureEvent: string().required("Nature of Event is required"),
    guestsExpected: string().required("No of Guests are required"),
    eventHall: string().required("Event Hall is Required"),
    eventRoom: string().required("Event Room is Required"),
  });

  const SignComponent = (): JSX.Element => {
    return (
      <>
        {CustomRequiredInputLabel("User’s Initial’s", true)}
        <CustomTextFeildforFamily />
      </>
    );
  };

  const [rowCount, setRowCount] = useState(1);
  const addMore = () => {
    // Increase the row count when "Add" button is clicked
    setRowCount(rowCount + 1);
  };

  const HallsDropdown = (currentHallName: string | false | undefined, fieldIndex: number): React.ReactElement => {
    return (
      <>
      {/* <div style={{width: '100%'}}> */}
      <Grid container spacing={2} style={{marginTop: '0px', marginLeft: '0px'}}>
      <Grid xs={12} sm={4} item>
      <Typography>Event Hall/Rooms to be used</Typography>
        <CustomSelectForHallContract
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Name of Hall"
          value={currentHallName}
          defaultValue=""
          id="grouped-select"
          onChange={(e) => {
            handleFieldChange("eventHallId", e.target.value, fieldIndex);
            setErrorMessage({ ...errorMessage, eventHall: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.eventHall ? styles.errorTextField : styles.textField
          }
        >
          {hallList.map((item: hallRentalListProps, index: number) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelectForHallContract>
      </Grid>
      
        {
          fieldIndex !== 0 && (<Grid xs={12} sm={1} item>
                          <img
                            style={{width: '30px', paddingTop: '25px', paddingLeft: '30px'}}
                            src={deleteIcon}
                            alt=""
                            onClick={() => {
                              if(rowCount > 1){
                                const updatedValue = cloneDeep(formData.contractForm.eventHallId);
                                updatedValue.splice(fieldIndex, 1);
                                setRowCount(rowCount - 1);
                                setFormData({
                                  ...formData,
                                  contractForm: {
                                    ...formData.contractForm,
                                    eventHallId: updatedValue,
                                  }
                                });
                              }
                            }}
                            />
                            </Grid>
          )
        }
        {
          fieldIndex === 0 && <Grid xs={12} sm={2} item>

          {hasManagerLevelRole && <CommonButton onClick={addMore} sx={{ margin: "24px" }}>
            Add
          </CommonButton>}
        </Grid>
        
        }
        {/* </div> */}
        </Grid>
      </>
    );
  };

  const commonFields = () => {
    let fields = [];
    for (let i = 0; i < rowCount; i++) {
      let currentHallName = '';
      let currentHallId: any;
      if(formData?.contractForm?.eventHallId?.[i]){
        currentHallId = formData.contractForm.eventHallId[i];
        const hallName = !isUndefined(hallList) && hallList?.find(item=> item.id === currentHallId)?.name;
        if(hallName){
          currentHallName = hallName
        }
        // currentHallName = !isUndefined(hallList) && hallList?.find(item=> item.id === currentHallId)?.name;
      }
      fields.push(HallsDropdown(currentHallId, i));
        // <tr>
        {/* <td> */}
        {/* <Grid container spacing={2} key={i}>
          <Grid xs={12} sm={12} item>
            <Typography>Event Hall/Rooms to be used</Typography> */}
            {}
            {/* <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={hallName}
              onChange={(e) => {
                handleFieldChange("eventHall", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  eventHall: "",
                });
              }}
              className={
                errorMessage.eventHall
                  ? styles.errorTextField
                  : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            /> */}
            
      // );
    }
    return fields;
  };
  // const commonFields = () => {
  //   return (
  //     <>
  //       <Grid xs={12} sm={4} item>
  //         <Typography>Number of Guests Expected</Typography>
  //         <CustomTextFeildForHallSchedule
  //           fullWidth
  //           required
  //           value={numberOfGuests}
  //           onChange={(e) => {
  //             handleFieldChange("guestsExpected", e.target.value);
  //             setErrorMessage({
  //               ...errorMessage,
  //               guestsExpected: "",
  //             });
  //           }}
  //           className={
  //             errorMessage.guestsExpected
  //               ? styles.errorTextField
  //               : styles.textField
  //           }
  //           inputProps={{
  //             readOnly: true,
  //           }}
  //         />
  //         {errorMessage.guestsExpected ? (
  //           <Typography sx={{ color: "red", fontSize: "12px" }}>
  //             {errorMessage.guestsExpected}
  //           </Typography>
  //         ) : (
  //           ""
  //         )}
  //       </Grid>
  //       <Grid xs={12} sm={4} item>
  //         <Typography>Nature of Event</Typography>
  //         <CustomTextFeildForHallSchedule
  //           fullWidth
  //           required
  //           value={eventType}
  //           onChange={(e) => {
  //             handleFieldChange("natureEvent", e.target.value);
  //             setErrorMessage({
  //               ...errorMessage,
  //               natureEvent: "",
  //             });
  //           }}
  //           className={
  //             errorMessage.natureEvent
  //               ? styles.errorTextField
  //               : styles.textField
  //           }
  //           inputProps={{
  //             readOnly: true,
  //           }}
  //         />
  //         {errorMessage.natureEvent ? (
  //           <Typography sx={{ color: "red", fontSize: "12px" }}>
  //             {errorMessage.natureEvent}
  //           </Typography>
  //         ) : (
  //           ""
  //         )}
  //       </Grid>
  //     </>
  //   );
  // };

  const formComponent = () => {
    return (
      <Grid className={styles.gridContainer}>
        <Grid container spacing={2}>
          <Grid xs={12} sm={4} item>
            <Typography>User’s Name</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={username}
              onChange={(e) => {
                handleFieldChange("username", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  username: "",
                });
              }}
              className={
                errorMessage.username ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.username ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.username}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Address</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={formData?.contractForm?.address}
              // value={formData.address}
              onChange={(e) => {
                handleFieldChange("address", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  address: "",
                });
              }}
              className={
                errorMessage.address ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.address ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.address}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Phone Number</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={sharedState.phoneNumber ? sharedState.phoneNumber : formData.contractForm.phoneNumber}
              onChange={(e) => {
                // handleFieldChange("contactEmail", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  contact: "",
                });
                setPhoneNumber(e.target.value);
              }}
              className={
                errorMessage.contact ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Phone number"
              inputProps={{
                readOnly: hasManagerLevelRole,
              }}
            />
            {errorMessage.contact ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.contact}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Email ID</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={formData.contractForm.email}
              onChange={(e) => {
                // handleFieldChange("email", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  contact: "",
                });
                setPhoneNumber(e.target.value);
              }}
              className={
                errorMessage.email ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Email ID"
              inputProps={{
                readOnly: hasManagerLevelRole,
              }}
            />
            {errorMessage.email ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.email}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Event Date</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={eventDate}
              onChange={(e) => {
                handleFieldChange("date", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  date: "",
                });
              }}
              className={
                errorMessage.date ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.date ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.date}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Event Time</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={eventTime}
              onChange={(e) => {
                handleFieldChange("time", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  time: "",
                });
              }}
              className={
                errorMessage.time ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.time ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.time}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pt: 2 }}>
          <Grid xs={12} sm={4} item>
            <Typography>No. of Event Room(s)</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value="1"
              onChange={(e) => {
                handleFieldChange("eventRoom", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  eventRoom: "",
                });
              }}
              className={
                errorMessage.eventRoom
                  ? styles.errorTextField
                  : styles.textField
              }
              inputProps={{
                readOnly: !hasManagerLevelRole,
              }}
            />
            {errorMessage.eventRoom ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.eventRoom}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Nature of Event</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={eventType}
              onChange={(e) => {
                handleFieldChange("natureEvent", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  natureEvent: "",
                });
              }}
              className={
                errorMessage.natureEvent
                  ? styles.errorTextField
                  : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Number of Guests Expected</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={formData.eventGuestCount}
              type="number"
              onChange={(e) => {
                handleFieldChange("eventGuestCount", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  guestsExpected: !e?.target?.value ? "Number of Guests required" : "",
                });
              }}
              className={
                errorMessage.guestsExpected
                  ? styles.errorTextField
                  : styles.textField
              }
              // inputProps={{
              //   readOnly: sessionStorage.getItem('selectedRole') === 'Manager' ? false : true,
              // }}
            />
            {errorMessage.guestsExpected ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.guestsExpected}
                </Typography>
              ) : (
                ""
              )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pt: 2 }}>

            {commonFields()}
        </Grid>
      </Grid>
    );
  };




  const updatedState = (newState: boolean) => {
    setNextStep(newState);
  }

  const handleInputChange = (e:any) => {
    setSign(e.target.value);
    setError("");
  };

  
  const handleClick = () => {
    if(!formData.eventGuestCount){
    }else if (sign.trim() === "" && status==undefined) {
      setError("Please enter user's initials");
    } else {
      setNextStep(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setFormData((prevState:any) => ({
        ...prevState,
        contractForm: {
          ...prevState.contractForm,
          phoneNumber: phoneNumber,
          agreementExecutionDate: prevState.bookingDate,
          devoteeInitials: sign
        },
      }));
    }
  };

  const FormStepContent = () => (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <span className={styles.currentNumberStyle}>1</span>{" "}
      <span className={styles.totalPagesNumberStyle}>/ 9</span>
    </div>
  );

  const navigationButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          startIcon={<ChevronLeftIcon />}
          disabled
        >
          Previous
        </CommonOutlinedButton>
        {FormStepContent()}
        <CommonButton
          endIcon={<KeyboardArrowRightIcon />}
          onClick={handleClick}
        >
          Next
        </CommonButton>
      </div>
    );
  };

 
function getMonthName(dateString:string) {
  
  const parts = dateString.split('-');
  const monthStr = parts[0];
  const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const month = parseInt(monthStr, 10);
  const monthName = monthNames[month - 1];
  return monthName ;
}


function getDayNumber(dateString:string) {
    const parts = dateString.split('-');
    const day = parseInt(parts[1], 10);
  return isNaN(day) ? "" : day;

}

function getYear(dateString:string) {
  const parts = dateString.split('-');
  const year = parseInt(parts[2], 10);
  return isNaN(year) ? "" : year;
}




  return (
    <>
      {!nextStep && <div> <Box className={styles.formOneWizard}>
        <Typography className={styles.typoGraphyHeading}>
          FACILITY USAGE AGREEMENT
        </Typography>
        {formComponent()}
        <Typography className={styles.typoGraphyText}>
          <span>*</span>see event hall and event rooms usage schedule (Page2 of 9)
        </Typography>
        <br />
        <Typography className={styles.typoGraphyText}>
          This agreement is executed at Livermore, CA on
          <CustomTextFeildForHallSchedule
          style={{width:"120px"}}
            value={sharedState.devoteeAgreementSignedDate ? getMonthName(sharedState.devoteeAgreementSignedDate): ""}
            className={
              errorMessage.address
                ? styles.errorTextField
                : styles.textTypographyField
            }
            onChange={(e) => {
              managerHandleFieldChange("agreementExecutionDay", e.target.value);
            }}
            inputProps={{
              readOnly: !hasManagerLevelRole,
            }}
            required={hasManagerLevelRole}
          />{" "}
          the day{" "}
          <CustomTextFeildForHallSchedule
          sx={{ width: "50px !important" }}
          value={sharedState.devoteeAgreementSignedDate  ? getDayNumber(sharedState.devoteeAgreementSignedDate) : ""}
            className={
              errorMessage.address
                ? styles.errorTextField
                : styles.textTypographyField
            }
            onChange={(e) => {
              managerHandleFieldChange("agreementExecutionMonth", e.target.value);
            }}

            inputProps={{
              readOnly: !hasManagerLevelRole,
            }}
            required={hasManagerLevelRole}
          />{" "}
          of
          <CustomTextFeildForHallSchedule
          value={sharedState.devoteeAgreementSignedDate ? getYear(sharedState.devoteeAgreementSignedDate) : ""} 
            sx={{ width: "100px !important" }}
            className={
              errorMessage.address
                ? styles.errorTextField
                : styles.textTypographyField
            }
            inputProps={{
              readOnly: !hasManagerLevelRole,
            }}
            onChange={(e) => {
              managerHandleFieldChange("agreementExecutionYear", e.target.value);
            }}

            required={hasManagerLevelRole}
          />{" "}
          . between the Hindu Community & Cultural Center (hereafter referred to
          as HCCC), a California Non-Profit organization located at 1232 Arrowhead
          Avenue, Livermore, CA 94550-6963 and the User with contact address as
          noted above. IT IS UNDERSTOOD AND AGREED THAT NO RESERVATION, CONFIRMED
          OR OTHERWISE SHALL BE BINDING ON THE HCCC UNLESS THIS AGREEMENT FORM IS
          SIGNED BY HCCC AND USER AND THE AMOUNTS REQUIRED HEREIN ARE RECEIVED IN
          FULL. THE HCCC RESERVES THE RIGHT TO DECLINE THE USAGE OF ITS FACILITIES
          TO ANYONE.
        </Typography>
        <br />
        <Typography
          className={styles.typoGraphyText}
          style={{ fontSize: "14px" }}
        >
          {" "}
          It is agreed between the parties hereto follows:
        </Typography>
        <br />
        <Typography className={styles.typoGraphyText}>
          CONTRACTED USABLE AREA: The HCCC hereby provides the User the facility,
          per the terms and conditions mentioned hereunder. In consideration of
          the permission given to the User, the User agrees and undertakes to
          accept the use of the Event Hall/Kitchen/Event Room of HCCC which is
          situated at 1200-1232 Arrowhead Avenue, in the city of Livermore, County
          of Alameda, California.
        </Typography>

      </Box>
        <FormFooter
          sign={sign}
          handleInputChange={handleInputChange}
          error={error}
          navigationButtons={navigationButtons()}
        />
      </div>}

      {nextStep && <HallBookingRequestResponseContext.Provider value={ sharedState }>
              <FormThree sign={sign} handleInputChange={handleInputChange} updateParentState={updatedState} formData={formData} />
      </HallBookingRequestResponseContext.Provider>   
}
    </>
  );
};

export default FacilityUsageAgreementForm;
